<template>
	<div>
		<spinner v-if="resumes.loading"/>
		<div v-else class="idi-table resumes">
			<div class="idi-header">
				<div class="idi-cell">{{ $t('labels.general.service') }}</div>
				<div class="idi-cell">{{ $t('labels.general.slots') }}</div>
				<div class="idi-cell">{{ $t('labels.general.in_use') }}</div>
				<div class="idi-cell">{{ $t('labels.general.available') }}</div>
			</div>
			<div class="idi-row-empty" v-if="!resumes.data.length">
				<div class="idi-cell">{{ $t('labels.general.empty') }}</div>
			</div>
			<div class="idi-row" v-for="resume in resumes.data" :key="resume.id">
				<div class="idi-cell">
					<span>{{ $t(serviceNamesTranslated.get(resume.service)) }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ resume.slots }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ resume.use }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ resume.slots - resume.use }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ApiCollection from '@/classes/api/ApiCollection'
export default {
	props: [
		'user_uid'
	],
	data () {
		return {
			resumes: new ApiCollection(),
			serviceNamesTranslated: new Map([ [ 'Rent watches', 'labels.general.rent_watches' ], [ 'Seats', 'labels.general.seats' ] ]),
		}
	},
	methods: {
		getResumes () {
			this.resumes.loading = true
			this.$api.subscriptions.getResume(this, this.user_uid)
				.then(response => {
					this.$log.info('subscriptions', 'subscriptions.getResume OK', response)()
					const data = []
					for (let resume in response.body) {
						data.push({ id: resume, service: response.body[resume].service, slots: response.body[resume].slots, use: response.body[resume].use })
					}
					this.resumes.data = data
				}).catch(error => {
					this.$log.error('subscriptions', 'subscriptions.getResume ERROR', error)()
					this.resumes.error = error
				}).finally(() => {
					this.resumes.loading = false
				})
		}
	},
	mounted () {
		this.getResumes()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/subscriptions/Resume.vue